package com.anjuros.website.templates.template10.util

import kotlinx.browser.document
import org.w3c.dom.HTMLLinkElement

/**
 * Loads the two Google fonts used only by this template (Shippori Mincho + Manrope).
 * Safe to call more than once – the link is added a single time.
 */
fun loadTemplate10Fonts() {
    val linkId = "template10-fonts"
    if (document.getElementById(linkId) != null) return
    val link = document.createElement("link") as HTMLLinkElement
    link.id = linkId
    link.rel = "stylesheet"
    link.href = Template10Constants.GOOGLE_FONTS_URL
    document.head?.appendChild(link)
}
